import { render } from "./DebugControls.vue?vue&type=template&id=60053991"
import script from "./DebugControls.vue?vue&type=script&lang=js"
export * from "./DebugControls.vue?vue&type=script&lang=js"

import "./DebugControls.vue?vue&type=style&index=0&id=60053991&media=screen&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__